import React from 'react';
import FilterableHeader from './components/FilterableHeader.js';
import { getFilterLabelsGroup, getFilterLabels } from './helper.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '@elliemae/ds-system/theme';
import './components/filterable-menus/getFilterMenuByType.js';
import './components/filterable-menus/DateRangeFilterMenu.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import '@elliemae/ds-basic/Button';
import 'moment';
import './components/filterable-menus/defaultDateFormat.js';
import './components/filterable-menus/SingleDateFilterMenu.js';
import './components/filterable-menus/SingleRangeSwitcherMenu.js';
import './components/filterable-menus/TextFilterMenu.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';

/* eslint-disable react/display-name */

function FilterableFormatter(_ref) {
  var grid = _ref.grid,
      onAddFilter = _ref.onAddFilter,
      onRemoveFilter = _ref.onRemoveFilter;
      _ref.query;
      var filterMenuRef = _ref.filterMenuRef;
  return function (value, _ref2) {
    var column = _ref2.column;

    var _grid$getInstance = grid.getInstance(),
        rows = _grid$getInstance.rows,
        composedRows = _grid$getInstance.composedRows,
        _grid$getInstance$pro = _grid$getInstance.props,
        groupedRows = _grid$getInstance$pro.groupedRows,
        groupedBy = _grid$getInstance$pro.groupedBy,
        onFilterMenuClose = _grid$getInstance$pro.onFilterMenuClose,
        onFilterMenuOpen = _grid$getInstance$pro.onFilterMenuOpen,
        filters = _grid$getInstance.state.filters;

    var rowsToUse = composedRows;

    if (column.filter && column.filter.isMulti) {
      rowsToUse = rows;
    }

    var filteredLabels = groupedRows && !groupedBy ? getFilterLabelsGroup(column, rows) : getFilterLabels(column, rowsToUse.rows || rowsToUse);
    var columnData = column.filterOptions || filteredLabels;
    return /*#__PURE__*/React.createElement(FilterableHeader, {
      column: column,
      columnData: columnData,
      filters: filters,
      filterMenuRef: filterMenuRef,
      onAddFilter: onAddFilter,
      onFilterMenuClose: onFilterMenuClose,
      onFilterMenuOpen: onFilterMenuOpen,
      onRemoveFilter: onRemoveFilter,
      isMulti: column.filter && column.filter.isMulti,
      value: value
    });
  };
}

export default FilterableFormatter;
//# sourceMappingURL=filterableFormatter.js.map
